import { render, staticRenderFns } from "./ProjectSchemaPreview.vue?vue&type=template&id=4503b173&"
import script from "./ProjectSchemaPreview.vue?vue&type=script&lang=js&"
export * from "./ProjectSchemaPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports